import { useFormatter } from "@/hooks/useFormatter";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { ProfileActions, ProfileDetailTabs, RESOURCE_TYPE_PROFILES } from "@/resources-def/profiles-comp";
import { useTranslation } from "react-i18next";


export const ProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const { formatDateTime } = useFormatter();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: RESOURCE_TYPE_PROFILES, key: record.id, action: 'show' });
  };

  const columns = [
    { title: t("settings.profiles.fields.name"), dataIndex: "name" },
    { title: t("settings.profiles.fields.desc"), dataIndex: "desc" },
    { title: t("instances.fields.created_on"), dataIndex: "created_on", render: (value) => formatDateTime(value) },
    { title: t("settings.profiles.fields.created_by"), dataIndex: "created_by" },
    { title: t("settings.profiles.fields.modified_on"), dataIndex: "modified_on", render: (value) => formatDateTime(value) },
    { title: t("settings.profiles.fields.modified_by"), dataIndex: "modified_by" },
  ];

  return (
    <ResourceListLayout
      title={t("settings.profiles.menu.label", "Instance Profiles")}
      resource={RESOURCE_TYPE_PROFILES}
      keyField="name"
      actions={ProfileActions}
      columns={columns}
      details={ProfileDetailTabs()}
    >
    </ResourceListLayout>
  );
};